@import '~style-sheet-helpers/core.less';

@import '../../../../../constants/spacing.module.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';

.api-key-title {
  margin-bottom: @space-8;
}

.api-key-content {
  display: flex;
  gap: @space-8;
}

.api-key-code {
  background-color: var(--gray-F4F6F8);
  padding: @space-4 @space-8;
  border-radius: @space-4;
  flex-grow: 1;
}

.api-key-button-icon {
  width: 24px;
  height: 24px;
  display: flex;
  padding: @space-4;
  align-items: center;
}

.api-key-icon {
  height: 100%;
  width: 100%;
}

.api-key-modal-confirmation-title {
  margin-bottom: @space-8;
}
